module.exports = __webpack_public_path__ + "img/castello-tv.de7de137.png";